import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RxFormGroup } from '@rxweb/reactive-form-validators';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class ReelsService {

	baseUrl = `${environment.apis.base}/reels`;

	constructor(private readonly http: HttpClient) { }

	datatable(page?: number, options?: any): Observable<Object> {
		let httpParams = new HttpParams();

		if (typeof page === 'number') {
			httpParams = httpParams.append('page', page);
		}

		if (options && 'key' in options && options?.key?.trim() !== '') {
			httpParams = httpParams.append('search', options.key);
		}

		if(options && 'filterById' in options) {
			httpParams = httpParams.append('id', options.filterById);
		}
		if (options && 'client_id' in options && options.client_id) {
			httpParams = httpParams.append('client_id', options.client_id);
		}

		return this.http.get<any>(this.baseUrl, {params: httpParams});
	}

	show(id: number): Promise<any> {
		const url = `${this.baseUrl}/${id}`;

		return this.http.get<any>(url).toPromise();
	}

	createOrUpdate(data: RxFormGroup, id?: number): Observable<Object> {
		let url = this.baseUrl;

		if (id) {
			url += `/${id}`;
			return this.http.put<any>(url, data.value);
		} else {
			return this.http.post<any>(url, data.value);
		}

	}

	saveMedias(data: any, id: number): Observable<Object> {
		const url = `${this.baseUrl}/${id}/save-medias`;
		return this.http.post<any>(url, data);
	}

	delete(id: number): Observable<Object> {
		const url = `${this.baseUrl}/${id}`;

		return this.http.delete<any>(url);
	}

	generateZip(): Observable<Object> {
		const url = `${this.baseUrl}/util/zip`;

		return this.http.get<any>(url);
	}

	getEvidences(date: any, macAddress: string): Observable<Object> {
		const url = `${this.baseUrl}/evidences/find-files?date=${date}&mac=${macAddress}`;

		return this.http.get<any>(url);
	}
}
